module.exports = __webpack_public_path__ + "img/svg.0dbbad46.svg";